'use client'

import Script from 'next/script'

const GA_TRACKING_ID = 'G-039ERDCPR0'

export function GoogleAnalytics() {
  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_TRACKING_ID}', {
            // Enhanced Measurement Configuration
            page_title: document.title,
            page_location: window.location.href,
            // Enable enhanced measurement features
            send_page_view: true,
            // Enable scroll tracking
            scroll_tracking: true,
            // Enable outbound link tracking
            outbound_link_tracking: true,
            // Enable site search tracking
            site_search_tracking: true,
            // Enable video engagement tracking
            video_tracking: true,
            // Enable file download tracking
            file_download_tracking: true,
            // Enable form interaction tracking
            form_tracking: true,
            // Enable engagement tracking
            engagement_time_msec: true,
            // Custom dimensions for better tracking
            custom_map: {
              'custom_parameter_1': 'page_type',
              'custom_parameter_2': 'user_type'
            }
          });
        `}
      </Script>
    </>
  )
} 